import * as React from "react";
import { forwardRef } from "react";
const SvgDropdown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 10, viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.02755 8.50187C6.49537 9.23929 5.39737 9.23929 4.86519 8.50187L0.254857 2.11361C-0.381542 1.23179 0.24856 1.32801e-07 1.33604 2.27872e-07L10.5567 1.03397e-06C11.6442 1.12904e-06 12.2743 1.23179 11.6379 2.11361L7.02755 8.50187Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDropdown);
export default ForwardRef;
